import { Container, Skeleton } from '@resolute/ui';

/**
 * Branded skeleton shown while a lazy route chunk loads.
 *
 * No height reservation is needed here: `PublicLayout` floors `main` at a
 * viewport, so this fallback and the real content that replaces it both start
 * the footer at or below the fold and nothing visible moves between them.
 */
export function RouteFallback() {
  return (
    <Container className="py-24">
      <div className="flex flex-col gap-6" aria-hidden="true">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-6 w-1/2" />
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-64 w-full" />
          ))}
        </div>
      </div>
      <span className="sr-only">Loading…</span>
    </Container>
  );
}
